import apiRequest from './apiRequest';

export default async function deleteBookmarkProject(projectID: string) {
  return await apiRequest(
    'mogen-orchestration',
    `/v2/projects/${projectID}/bookmark`,
    {
      method: 'DELETE',
    },
  );
}
